<div [class]="visible ? 'flex flex-col h-full' : 'hidden'">
  <div class="h-full flex flex-col ">
    <div class="mb-3">
      <button [disabled]="parent.isReadOnly()" (click)="onRtAdd()" pButton type="button" label="Add Rapid Order"
        icon="pi pi-plus" class="p-button-sm"></button>
    </div>
    <div class="mb-3">
      <h6><i>Remember! Set default Rapid Order Detail quantities by clicking on the caret (>) next to the Rapid
          Order after Attaching Products</i></h6>
    </div>
    <div class="grow">
      <prox-ag-grid gridId="rapidTemplatesGrid" [gridOptions]="rtGridOptions" [rowData]="rapidTemplates"></prox-ag-grid>
    </div>
  </div>
</div>